<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn @click="addClick" class="ml-0" color="success">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{$t('buttons.addCompany')}}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="true"
						:headers="companiesTable.headers"
						:items="companiesTable.items"
						:total="companiesTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.id, false)">{{ props.item.name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.address }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.city }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.country.name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.phone }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.email }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.subject.subject_type.name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.date_added_display }}</td>
								<td @click="editClick(props.item.id, false)">
									<v-icon small v-if="props.item.active">fa-check</v-icon>
								</td>
								<td>
									<v-tooltip bottom>
										<v-btn @click="editClick(props.item.id, true)" icon slot="activator">
											<v-icon small>fa-external-link-alt</v-icon>
										</v-btn>
										<span>{{$t('tooltips.openInNewTab')}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import DataTable from "./trinkets/DataTable";

	export default {
		name: "Companies",
		components: {DataTable},
		data: function () {
			return {
				companiesTable: {
					headers: [
						{text: this.$t('fields.name'), value: 'name', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.address'), value: 'address', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.city'), value: 'city', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.country'), value: 'country', type: 'dropdown|countries', searchable: 'hidden'},
						{text: this.$t('fields.phone'), value: 'phone', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.email'), value: 'email', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.subjectType'), value: 'subject_type', type: 'dropdown|subject-types', searchable: 'hidden'},
						{text: this.$t('fields.dateAdded'), value: 'date_added', type: 'date_range', searchable: 'hidden'},
						{text: this.$t('fields.active'), value: 'active', type: 'boolean_yes', width: "100px", searchable: 'hidden'},
						{text: '', value: 'actions', type: '', sortable: false, align: "right", width: "100px", searchable: false}
					],
					items: [],
					total: 0,
					lastRequest: null
				},

			}
		},
		methods: {
			addClick() {
				this.$router.push('/companies/0')
			},
			editClick(id, newTab = false) {
				if (!newTab) {
					this.$router.push('/companies/' + id)
				} else {
					let routeData = this.$router.resolve('/companies/' + id);
					window.open(routeData.href, '_blank');
				}
			},
			reloadData(request) {
				this.lastRequest = request;
				let vm = this;
				this.$APICall('get', 'companies', request, (data, success) => {
					if (success) {
						vm.companiesTable.items = data.items;
						vm.companiesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			},
			excelExport() {
				let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
				excelRequest.pagination.rowsPerPage = 999999999;
				excelRequest.pagination.page = 1;

				let vm = this;
				this.$APICall('get', 'companies', excelRequest, (data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/companies', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.companies'), href: '/#/companies', disabled: true}
			]);
		}
	}
</script>

<style scoped>

</style>
